import React, { useState } from "react";
import { Box, Paper, Typography, Button, IconButton } from "@mui/material";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import ErrorIcon from "@mui/icons-material/Error";
import InfoIcon from "@mui/icons-material/Info";
import CloseIcon from "@mui/icons-material/Close";

const typeConfig = {
  critical: { icon: <ErrorIcon sx={{ fontSize: 18, color: "#ef4444" }} />, bg: "rgba(239,68,68,0.08)", border: "#fecaca", color: "#991b1b" },
  warning: { icon: <WarningAmberIcon sx={{ fontSize: 18, color: "#f59e0b" }} />, bg: "rgba(245,158,11,0.08)", border: "#fde68a", color: "#92400e" },
  info: { icon: <InfoIcon sx={{ fontSize: 18, color: "#3b82f6" }} />, bg: "rgba(59,130,246,0.08)", border: "#bfdbfe", color: "#1e40af" },
};

export default function AlertsWidget({ alerts, onDismiss }) {
  const [dismissed, setDismissed] = useState([]);

  const visibleAlerts = (alerts || []).filter((_, i) => !dismissed.includes(i));

  const handleDismiss = (index) => {
    setDismissed(prev => [...prev, index]);
    if (onDismiss) onDismiss(index);
  };

  return (
    <Paper className="glass-card" sx={{ p: 3 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
        <NotificationsActiveIcon sx={{ color: visibleAlerts.some(a => a.type === "critical") ? "#ef4444" : "#6366f1", fontSize: 22 }} />
        <Typography fontWeight={700} fontSize={15} color="#1e293b">Alerts ({visibleAlerts.length})</Typography>
      </Box>
      {visibleAlerts.length === 0 ? (
        <Box sx={{ textAlign: "center", py: 3 }}>
          <NotificationsActiveIcon sx={{ fontSize: 32, color: "#cbd5e1", mb: 1 }} />
          <Typography variant="body2" color="#94a3b8">No active alerts</Typography>
        </Box>
      ) : (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          {visibleAlerts.map((alert, i) => {
            const config = typeConfig[alert.type] || typeConfig.info;
            return (
              <Box key={i} sx={{ display: "flex", alignItems: "flex-start", gap: 1.5, p: 1.5, borderRadius: 2, bgcolor: config.bg, border: `1px solid ${config.border}` }}>
                {config.icon}
                <Typography variant="body2" color={config.color} fontWeight={500} sx={{ flex: 1, fontSize: 13 }}>{alert.message}</Typography>
                <IconButton size="small" onClick={() => handleDismiss(i)} sx={{ p: 0.5 }}>
                  <CloseIcon sx={{ fontSize: 14, color: "#94a3b8" }} />
                </IconButton>
              </Box>
            );
          })}
        </Box>
      )}
    </Paper>
  );
}
